import { useSelector } from 'react-redux';
import FJImageInputTwo from '../../../../common/components/FJImageInput/FJImageInputTwo';
import FJConstant from '../../../../constants/FJConstant';
import { useCallback, useMemo } from 'react';
import FJActionWatermarkRemover from '../../../../redux/action/FJActionWatermarkRemover';
import { useDispatch } from 'react-redux';
import {
    UPLOAD_FILE_TYPE_NO_GIF,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import FJButtonInCreditIcon from '../../../../common/components/FJButtonInCreditIcon';
import { WATERMARK_REMOVER_USE_CREDIT } from '../../../../redux/slices/FJSliceWatermarkRemover.js';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';

const FJImageInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const isFree = useMemo(() => {
        return freeNumCreation > 0 && creditNumber < WATERMARK_REMOVER_USE_CREDIT;
    }, [freeNumCreation, creditNumber]);

    const _uploadImage = useCallback(
        file => {
            dispatch(FJActionWatermarkRemover.uploadImageAction(file));
        },
        [dispatch],
    );

    const _openMediaLibrary = useCallback(() => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode: UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    }, [dispatch]);

    // const isGenerating = FJUtil.isGeneratingStatus(taskStatus);

    const defaultFreeNumCreation = useDefaultFreeLimit();

    return (
        <FJImageInputTwo
            openMediaLibrary={_openMediaLibrary}
            disabled={taskStatus !== FJConstant.DEFAULT && taskStatus !== FJConstant.ERROR}
            uploadImg={_uploadImage}
            isSmallComponent={false}
            // isLoading={isGenerating}
            tipsText={'confirm-image-rights'}
            text={'click-or-drag-to-upload-image'}
            isShowTips={true}
            rightDraggingFile={isDraggingFile}
            acceptFile={UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES}
            icon={
                <FJButtonInCreditIcon
                    isFree={isFree}
                    freeNumCreation={freeNumCreation}
                    useCredit={WATERMARK_REMOVER_USE_CREDIT}
                    defaultFreeNumCreation={defaultFreeNumCreation}
                />
            }
        />
    );
};

export default FJImageInputContainer;
